import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function changeValueFormat(
  value: number | null | undefined,
  showPercentages: boolean,
  intl: Services['intl'],
) {
  if (!Number.isFinite(value) || value === undefined || value === null) {
    return intl.t(tKey('general.not_available_short'));
  }

  const roundedValue = Math.round(value);

  if (showPercentages) {
    return `${intl.formatNumber(roundedValue, { signDisplay: 'exceptZero' })} pt`;
  }

  return intl.formatNumber(roundedValue, { signDisplay: 'exceptZero' });
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function changeValuePercentageSignFormat(
  value: number,
  intl: Services['intl'],
) {
  if (!Number.isFinite(value)) {
    return intl.t(tKey('general.not_available_short'));
  }

  const roundedValue = Math.round(value);

  return intl.formatNumber(roundedValue / 100, { style: 'percent' });
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function valueFormat(
  value: number | null | undefined,
  showPercentages: boolean,
  intl: Services['intl'],
) {
  if (!Number.isFinite(value) || value === undefined || value === null) {
    return intl.t(tKey('general.not_available_short'));
  }

  const roundedValue = Math.round(value);

  if (showPercentages) {
    return intl.formatNumber(roundedValue / 100, { style: 'percent' });
  }

  return intl.formatNumber(roundedValue);
}
